import { render, staticRenderFns } from "./AllUsersActivityPage.vue?vue&type=template&id=012c6a16&scoped=true"
import script from "./AllUsersActivityPage.vue?vue&type=script&lang=js"
export * from "./AllUsersActivityPage.vue?vue&type=script&lang=js"
import style0 from "./AllUsersActivityPage.vue?vue&type=style&index=0&id=012c6a16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "012c6a16",
  null
  
)

export default component.exports